import styled, { css } from 'styled-components';
import Chevron from '@widgets/shared/components/icons/Chevron';
import { datepickerHeaderButton, datepickerHeaderHeading, datepickerHeaderWrapper, } from '@widgets/shared/components/CustomDatepicker/components/DatepickerHeader/styles/default';
export const ButtonIcon = styled(Chevron) ``;
const Button = styled.button `
  ${datepickerHeaderButton}

  ${({ theme: { calendarHeaderButtons } }) => calendarHeaderButtons}
  
  
  ${({ isPrev }) => isPrev && css `
    ${ButtonIcon}{
      transform: rotate(-180deg);
    }
  `}
  
  ${({ disabled }) => disabled && css `
    opacity: .5;
  `}
`;
export const Heading = styled.span `
  ${datepickerHeaderHeading}

  ${({ theme: { calendarHeading } }) => calendarHeading}
`;
export const Wrapper = styled.div `
  ${datepickerHeaderWrapper}
`;
export default {
    Button,
    ButtonIcon,
    Heading,
    Wrapper,
};
